import { useEffect, useState } from 'react';
import { Card, Empty, ErrorBanner, Stat } from '../components/Layout.jsx';
import { apiFetch } from '../store.js';

export default function BrandPerformance() {
  const [brand, setBrand] = useState('');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function load(e) {
    e?.preventDefault();
    const b = brand.trim();
    if (!b) return;
    setBusy(true);
    setError(null);
    try {
      const d = await apiFetch(`/dashboard/brand-performance/${encodeURIComponent(b)}`);
      setData(d);
    } catch (err) {
      setError(err);
      setData(null);
    } finally {
      setBusy(false);
    }
  }

  const totals = data?.totals || {};
  const recent = data?.recent || [];

  return (
    <>
      <ErrorBanner error={error} />

      <Card title="Brand performance">
        <form onSubmit={load} style={{ display: 'flex', gap: 'var(--space-sm)' }}>
          <input
            placeholder="Brand key (e.g. onlyjalen)"
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            style={{ flex: 1 }}
          />
          <button className="btn" type="submit" disabled={busy || !brand.trim()}>
            {busy ? 'Loading…' : 'Load'}
          </button>
        </form>
      </Card>

      {data && (
        <>
          <Card title={`Totals — ${data.brand}`}>
            <div className="stats-row">
              <Stat label="Analyses" value={totals.analyses_total ?? 0} />
              <Stat
                label="Avg latency"
                value={totals.avg_latency_ms != null ? `${Math.round(totals.avg_latency_ms)}ms` : '—'}
              />
              <Stat label="Neutral" value={totals.neutral_count ?? 0} />
              <Stat label="Flirty" value={totals.flirty_count ?? 0} />
              <Stat label="Explicit" value={totals.explicit_count ?? 0} />
            </div>
          </Card>

          <Card title="Recent (50)">
            {recent.length === 0 ? <Empty>No analyses yet.</Empty> : (
              <table>
                <thead>
                  <tr>
                    <th>ID</th><th>Engine</th><th>Tone</th>
                    <th>Length</th><th>Latency</th><th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {recent.map((r) => (
                    <tr key={r.id}>
                      <td><code>{r.id}</code></td>
                      <td>{r.engine_name || '—'}</td>
                      <td>{r.tone || '—'}</td>
                      <td>{r.length || '—'}</td>
                      <td>{r.latency_ms ?? '—'}ms</td>
                      <td>{r.created_at || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card>
        </>
      )}
    </>
  );
}
